import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// -------------------------------

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const sliderBannerPage = document.querySelector(".banner-page-slider-js");
  let swiper;
  if (sliderBannerPage) {
    swiper = new Swiper(".banner-page-slider-js", {
      modules: [Pagination, Autoplay],
      loop: true,
      speed: 1000,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }

  // -------------------------------

  const sectionMain = document.getElementById("page-anim-js");
  const header = document.querySelector(".header-js");

  if (sectionMain) {
    const tl = gsap.timeline({ paused: true });
    tl.fromTo(".page-anim-label-js", { autoAlpha: 1 }, { autoAlpha: 0 }, 0)
      .fromTo(".page-anim-title-js", { autoAlpha: 1 }, { autoAlpha: 0 }, 0)
      .fromTo(".page-anim-desc-js", { autoAlpha: 1 }, { autoAlpha: 0 }, 0)
      .fromTo(
        ".page-anim-img-js",
        { yPercent: 0, scale: 1, ease: "none" },
        { yPercent: 20, scale: 1.4, ease: "none" },
        0
      )
      .fromTo(
        ".page-anim-overlay-js",
        { opacity: 0.3, ease: "none" },
        { opacity: 0.9, ease: "none" },
        0
      );

    const tlHeaderMain = gsap.timeline({ paused: true });
    tlHeaderMain.to(header, { autoAlpha: 0 });

    const transformer = gsap.utils.pipe(gsap.utils.mapRange(0, 0.2, 0, 1));

    ScrollTrigger.create({
      trigger: sectionMain,
      start: "top+=10 top",
      end: "bottom top",
      scrub: 0.1,
      fastScrollEnd: true,
      invalidateOnRefresh: true,
      // markers: true,
      onUpdate: ({ progress }) => {
        tl.progress(progress);
        tlHeaderMain.progress(transformer(progress));
      },
      onEnterBack: () => {
        gsap.set(header, { autoAlpha: 0 });
      },
      onEnter: () => {
        if (swiper && !swiper.autoplay.paused) {
          swiper.autoplay.pause();
        }
        sliderBannerPage && sliderBannerPage.classList.remove("active");
      },
      onLeaveBack: () => {
        if (swiper && swiper.autoplay.paused) {
          swiper.autoplay.resume();
        }
        sliderBannerPage && sliderBannerPage.classList.add("active");
      },
    });
    // -------------------------------
  }
});
